import { render, staticRenderFns } from "./CatalogHorizontalTile.vue?vue&type=template&id=48ae6c25&scoped=true&"
import script from "./CatalogHorizontalTile.vue?vue&type=script&lang=ts&"
export * from "./CatalogHorizontalTile.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogHorizontalTile.vue?vue&type=style&index=0&id=48ae6c25&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ae6c25",
  null
  
)

export default component.exports